var map = {
	"./All_flour_Mills.mp4": 18018,
	"./Manufacturing1.png": 25438,
	"./Manufacturing2.png": 27541,
	"./Manufacturing3.png": 44652,
	"./Manufacturing4.png": 74819,
	"./PREMIUM(1).mp4": 6515,
	"./PREMIUM(2).mp4": 97894,
	"./PREMIUM.mp4": 65961,
	"./Plug_It.png": 96025,
	"./RIDHI_SIDHI_FLOUR_MILLS.png": 63980,
	"./RIDHI_SIDHI_FLOUR_MILLS_1.png": 28444,
	"./RIDHI_SIDHI_FLOUR_MILLS_2.png": 12727,
	"./RIDHI_SIDHI_FLOUR_MILLS_3.png": 69710,
	"./RIDHI_SIDHI_FLOUR_MILLS_4.png": 22177,
	"./RIDHI_SIDHI_FLOUR_MILLS_5.png": 37560,
	"./RIDHI_SIDHI_FLOUR_MILLS_6.png": 12051,
	"./RIDHI_SIDHI_FLOUR_MILLS_7.png": 73194,
	"./RIDHI_SIDHI_FLOUR_MILLS_8.png": 7261,
	"./door-manufacturers1-door-manufacturers-1-dgovo.avif": 29479,
	"./img1.jpg": 96047,
	"./img2.png": 83236,
	"./img3.png": 9389,
	"./img4.png": 27826,
	"./img5.jpg": 48915,
	"./img5.png": 76827,
	"./img6.png": 38144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33045;